/**
 *  Filename ....: medfamlookup.component.ts
 *  Created by ..: ianday
 *  on Date .....: 4/27/25
 **/
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MedicationFamily } from '../../../../models/medicationfamily';
import { MatLegacyTableDataSource } from "@angular/material/legacy-table";
import { Medication } from "../../../../models/medication";

@Component({
	selector: 'app-medfamlookup',
	templateUrl: './medfamlookup.component.html',
	styleUrls: ['./medfamlookup.component.css']
})

export class MedFamLookupComponent implements OnInit {

	public records: Array<MedicationFamily>;
	public displayedColumns = ['itemPrefix', 'description', 'schedule'];
	public selectedRecord: MedicationFamily;
	public dataSource: MatLegacyTableDataSource<MedicationFamily>;
	public Idx = -1;
	public busyCursor = false;
	public hideNoRecs = false;
	public pagination: string;
	public valFilter: string = '';
	public displayQuickAddMedFamilyDlg = false;

	@Input() set MedFamRecords(inp: MedicationFamily[] | null | undefined) {

		if (!inp || !Array.isArray(inp)) {
			this.records = [];
			this.dataSource = new MatLegacyTableDataSource(this.records);
			return;
		}

		inp.forEach(x => {
			const prefix = x?.itemPrefix?.toString().trim();

			if (prefix && prefix.length > 0) {
				x.itemPrefix = prefix.padStart(4, '0');
			} else {
				x.itemPrefix = '';
			}
		});

		this.records = inp;
		this.dataSource = new MatLegacyTableDataSource(this.records);
	}

	@Output() submitClicked = new EventEmitter();
	@Output() cancelClicked = new EventEmitter();

	constructor() {

	}
	public ngOnInit() {

	}
	public setTableData(filterVal: string): void {


		this.setPagination(-1, this.dataSource.filteredData.length);
		this.applyFilter(filterVal);
		this.hideNoRecs = true;
	}
	public onSortChange(event) {
		//this.saveSortEvent = event;
		if (this.dataSource === undefined || this.records === undefined) {
			return;
		}
		try {
			const propComparator = (a: any, b: any) => {
				const propA = this.getPropertyValue(a[event.active]);
				const propB = this.getPropertyValue(b[event.active]);

				if (typeof propA === 'number' && typeof propB === 'number') {
					return event.direction === 'asc' ? propA - propB : propB - propA;
				} else if (propA instanceof Date && propB instanceof Date) {
					return event.direction === 'asc' ? propA.getTime() - propB.getTime() : propB.getTime() - propA.getTime();
				} else {
					const propAStr = propA.toString();
					const propBStr = propB.toString();
					return event.direction === 'asc' ? propAStr.localeCompare(propBStr) : propBStr.localeCompare(propAStr);
				}
			};

			this.dataSource.data = this.dataSource.data.sort(propComparator);
			this.selectRow();

		} catch (e) {
			console.log(e);
		}
	}
	public applyFilter(filterValue: any): void {
		this.valFilter = filterValue;
		this.dataSource.filter = filterValue.trim().toLowerCase();
		this.unSelectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}
	public setPagination(idx: number, total: number) {
		this.pagination = (idx + 1) + '/' + total;
	}
	public clearFilter(): void {
		this.unSelectRow();
		this.dataSource.filter = '';
		this.selectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}
	public getPropertyValue(value: any): any {
		// Handle special cases for specific data types (e.g., date, number)
		// Add more cases as needed based on the data types
		if (value instanceof Date) {
			return value;
		} else if (!isNaN(value)) {
			return parseFloat(value);
		} else {
			return value ?? '';
		}
	}
	public selectRow(): void {

		if (this.selectedRecord === undefined || this.selectedRecord.id === 0) {
			this.unSelectRow();
		}
		this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRecord.id);
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}
	public unSelectRow(): void {
		this.Idx = -1;
		this.selectedRecord = new MedicationFamily();
	}
	public tableKeyDown(event: KeyboardEvent): void {

		const len: number = this.dataSource.filteredData.length;
		if (event.key === 'ArrowDown') {
			if (this.Idx < (len - 1)) {
				this.selectedRecord = this.dataSource.filteredData[++this.Idx];
			}
		} else if (event.key === 'ArrowUp') {
			if (this.Idx > 0) {
				this.selectedRecord = this.dataSource.filteredData[--this.Idx];
			}
		}
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}
	public onRowClicked(record: any, idx): void {
		this.selectedRecord = record;
		this.Idx = idx;
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}
	public onDoubleClickRow(event: any, idx): void {
		this.onRowClicked(event, idx);
		this.submitRecord();
	}
	public submitRecord(): void {
		this.submitClicked.emit(this.selectedRecord);
	}
	public cancelSubmitRecord(): void {
		this.cancelClicked.emit();
	}

	addNewHandler() {
		this.displayQuickAddMedFamilyDlg = true;

	}
	quickMedFamilyAddedHandler(data: MedicationFamily) {
		this.records.push(data);
		this.selectedRecord = data;
		this.valFilter = data.description;
		this.applyFilter(data.description);
		this.displayQuickAddMedFamilyDlg = false;
	}

}


